import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { isEqual } from 'lodash'
import EventEmitter from '../../../utils/events'
import { isiOS } from '../../../constants'

// Actions
import { triggerMenu } from '../../../actions/backdrop'
import { getHeaderInfo, setHeaderInfo, openOverlay } from '../../../actions/common'
import { setOrdersFilter, getOrdersAdvanced, UpdateEconomicMatch, setOrdersSearch } from '../../../actions/orders'

// import components
import Menu from '../Menu'
import UserMenu from '../UserMenu'
import NewsFeed from '../NewsFeed'
import TopBar from './TopBar'
import ShortCutBar from './ShortCutBar'

// import Null from '../../elements/null'
import Icon from '../../elements/icon'
import { HeaderIcons } from '../../elements/icons'

// import styles
import '../../theme/layout.scss'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { isTouchDevice } from '../../../utils/detect'
import { translation } from '../../../utils/helpers'

// Elements
import Check from '../../elements/check'

// Overlays
import ReportMergeOverlay from '../../overlays/ReportMerge'

class Layout extends Component {
  constructor (props) {
    super(props)
    this.state = {
      headerInfo: {
        Updates_open: false,
        ManualMerges_open: false,
        ForsiActive_open: false
      },
      headerInfos: props.headerInfo,
      timerId: -1,
      selectedReportMergeInfo: undefined
    }
    this.openMenu = this.openMenu.bind(this)
    this.handle = this.handle.bind(this)
    this.toggleHeaderInfo = this.toggleHeaderInfo.bind(this)
    this.updateHeaderInfo = this.updateHeaderInfo.bind(this)
    this.UpdateEconomicMatch = this.UpdateEconomicMatch.bind(this)
    this.getHeaderInfo = this.getHeaderInfo.bind(this)
    this.startTimer = this.startTimer.bind(this)
    this.stopTimer = this.stopTimer.bind(this)
    this.tickTimer = this.tickTimer.bind(this)
    this.searchEconomicNotMatched = this.searchEconomicNotMatched.bind(this)
  }

  componentDidMount () {
    document.addEventListener('click', this.handle, true)
    this.getHeaderInfo()
    this.initSocket()
    this.startTimer()

    if (isiOS) {
      document.body.classList.add('iOS')
    }
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handle, true)
    EventEmitter.removeListener('HEADER_INFO', this.updateHeaderInfo)
    this.stopTimer()
  }

  startTimer () {
    // timer should not be needed anymore with wp socket updates, but is kept for just in case when socket does not update
    let loc = window.location
    if (this.state.timerId > -1 || !hasAccess([6], this.props.auth.user.UserType) || loc.hostname === 'localhost') return // Only start one timer, and only for wp
    this.setState({
      timerId: setInterval(this.tickTimer, 30000)
    }, () => {
      console.log('[Layout] started timer, id: ' + this.state.timerId)
    })
  }

  stopTimer () {
    clearInterval(this.state.timerId)
    this.setState({
      timerId: -1
    }, () => {
      console.log('[Layout] stopped timer')
    })
  }
  tickTimer () {
    console.log('[Layout] timer ticked, id: ' + this.state.timerId)
    this.getHeaderInfo()
  }
  componentWillReceiveProps (nextProps) {
    // if (this.props.auth.user.ShopId !== nextProps.auth.user.ShopId) {
    // console.log('Layout props', nextProps.auth)
    if (!isEqual(this.props.auth.user, nextProps.auth.user) || !isEqual(this.props.auth.myscreen.Active, nextProps.auth.myscreen.Active)) {
      // console.log('[Layout] props', nextProps.auth)
      if (nextProps.auth.prevWorkscreen !== null || nextProps.auth.myscreen.Active) {
        console.log('[Layout] AUTH NOT THE SAME, set workscreen to', nextProps.auth.prevWorkscreen)
        window.localStorage.setItem('workscreen_view', nextProps.auth.prevWorkscreen)
      }
      this.stopTimer()
      setTimeout(() => {
        this.getHeaderInfo()
        this.startTimer()
      }, 500)
    }
    if (!isEqual(this.props.headerInfo, nextProps.headerInfo)) {
      this.state.headerInfos = nextProps.headerInfo
    }
  }

  initSocket () {
    // Fix init socket
    // window.sock.send(JSON.stringify({
    //   Type: 'CONNECTION',
    //   ShopId: parseInt(this.props.auth.user.ShopId)
    // }))
    EventEmitter.removeListener('HEADER_INFO', this.updateHeaderInfo)
    EventEmitter.addListener('HEADER_INFO', this.updateHeaderInfo, this)
  }

  searchEconomicNotMatched (e) {
    // e.preventDefault()
    // this.props.resetFilter()
    let source = 'orderlist'
    if (hasAccess([4], this.props.auth.user.UserType)) {
      source = 'customer'
    } else if (hasAccess([6], this.props.auth.user.UserType)) {
      source = 'wp'
    } else if (this.props.router.location.pathname === '/workscreen') {
      source = 'workscreen'
    }

    let filter = JSON.parse(JSON.stringify(this.props.filter))
    filter.economicfilter = {
      economicFilterNotMatched: true,
      economicFilterMatched: false
    }
    filter.process = {
      ...filter.process,
      InProcess: true,
      CompletedThisWeek: true,
      Completed: true
    }
    this.props.setOrdersSearch(true)
    this.props.setOrdersFilter(filter, source)
    setTimeout(() => {
      if (this.props.router.location.pathname === '/orders') {
        // TODO: Actually search again if in orderslist
        this.props.getOrdersAdvanced(filter, this.props.auth.user.UserType)
        this.toggleHeaderInfo()
      } else {
        this.props.router.replace('/orders')
        this.toggleHeaderInfo()
      }
    }, 50)
  }

  updateHeaderInfo (data) {
    // console.log('Update header info', data) // noget går galt her.
    switch (data.Type) {
      case 'HEADER_INFO_FORSI':
        this.props.setHeaderInfo('SET_HEADERINFO_FORSI', 'ForsiActive', data.Data.Active)
        break
      case 'HEADER_INFO_MESSAGES':
        const dataObject = data.Data
        // Other task
        if (dataObject.Type === 2) {
          if (dataObject.UserId === this.props.auth.user.UserId) {
            this.props.setHeaderInfo('SET_HEADERINFO_TASKS', 'IncompletedTasks', dataObject.Count)
          }
        } else {
          // Messages
          data.Data.map((val) => {
            if (val.UserId === this.props.auth.user.UserId) {
              this.props.setHeaderInfo('SET_HEADERINFO_MESSAGES', 'UnreadMessages', val.Count)
            }
          })
        }
        break
      case 'HEADER_INFO_EVALUATION':
        this.props.setHeaderInfo('SET_HEADERINFO_EVALUATION', 'Updates', data.Data)
        break
      case 'HEADER_INFO_UPDATES':
        if (data.Data.Type === 2) {
          this.props.setHeaderInfo('SET_HEADERINFO_BOOKINGPORTALDRAFTS', 'BookingPortalDrafts', data.Data.BookingPortalDrafts)
        } else if (data.Data.OrderAssignmentCount !== undefined) {
          data.Data.OrderAssignmentCount.map((val) => {
            if (val.UserId === this.props.auth.user.UserId) {
              this.props.setHeaderInfo('SET_HEADERINFO_ORDERS', 'AssignedOrders', val.AssignedCount)
            }
          })
        } else {
          this.props.setHeaderInfo('SET_HEADERINFO_UPDATES', 'ManualMerges', data.Data)
        }
        break
      case 'HEADER_INFO_CHAINNOTIFICATION':
        this.props.setHeaderInfo('SET_HEADERINFO_CHAINNOTIFICATION', 'ChainNotification', data.Data[0].Message)
        break
    }
  }

  getHeaderInfo () {
    if (!hasAccess([3, 4, 5, 6, 7], this.props.auth.user.UserType)) return null
    this.props.getHeaderInfo(0)
  }

  openMenu () {
    if (!this.props.backdrop.menuOpen) {
      // document.getElementById('app').className = 'menu-open'
      document.getElementById('app').classList.add('menu-open')
    } else {
      document.getElementById('app').classList.remove('menu-open')
      // document.getElementById('app').className = ''
    }
    this.props.triggerMenu(!this.props.backdrop.menuOpen)
  }

  UpdateEconomicMatch (item, e) {
    let matches = [...this.state.headerInfos.EconomicMatches]
    if (matches === null) return null
    item.Checked = !item.Checked
    for (let i = 0; i < matches.length; i++) {
      if (matches[i].OrderId === item.OrderId) {
        matches[i] = item
      }
    }
    this.props.UpdateEconomicMatch(item)
    this.setState({
      headerInfos: {
        ...this.state.headerInfos,
        EconomicMatches: matches
      }
    }, () => {
      console.log('matches', matches)
    })
  }

  renderTitle (item) {
    let title = ''
    // Model
    if (item.Model) {
      title += item.Model
    }
    // RegNumber
    if (item.RegNr) {
      if (item.Model) {
        title += ', '
      }
      title += item.RegNr
    }
    // Title empty
    if (title === '') {
      title += item.OrderId
    }
    return title
  }

  handle (e) {
    let pathTest = []
    let node = e.target
    while (node !== null && node !== document && node !== document.body) {
      pathTest.push(node)
      node = node.parentNode
    }
    // this.toggleHeaderInfo()
    // if (!(e.path.filter(x => x.className === 'headerInfos').length === 1)) this.toggleHeaderInfo() // only works in Chrome
    if (!(pathTest.filter(x => x.className === 'headerInfos').length === 1)) this.toggleHeaderInfo()

    if (!hasAccess([3, 5, 7], this.props.auth.user.UserType)) return null
    // if (!el.contains(e.target) && this.state.headerInfo.open) this.toggleHeaderInfo()
  }

  toggleHeaderInfo (name) {
    this.setState({
      headerInfo: {
        // ...this.state.headerInfo,
        Updates_open: false,
        ManualMerges_open: false,
        ForsiActive_open: false,
        EconomicMatches_open: false,
        [name]: !this.state.headerInfo[name]
      }
    })
  }

  renderHeaderInfo () {
    let { headerInfo, auth } = this.props
    if (!hasAccess([3, 5, 6, 7], auth.user.UserType)) return null
    // Render updates
    const renderUpdates = (item, key) => {
      return (
        <li key={key}><Link to={'/pricecalculation/' + item.OrderId + '/3'} onClick={this.toggleHeaderInfo}>- {this.renderTitle(item)}</Link></li>
      )
    }
    const renderEconomicMatches = (item, key) => {
      return (
        <li key={key}>
          <Check labelText={`- ${this.renderTitle(item)} (${item.CustomerName})`} checked={item.Checked} onChange={this.UpdateEconomicMatch.bind(this, item)} />
        </li>
      )
    }
    const renderMerge = (item, key) => {
      const onClick = _ => {
        this.toggleHeaderInfo()
        this.props.openOverlay('ReportMergeOverlay')
        this.setState({ selectedReportMergeInfo: item })
      }
      return <li key={key}><Link to={window.location.pathname} replace onClick={onClick}>- {this.renderTitle(item)}</Link></li>
    }
    const renderBookingPortalDraft = (item, key) => {
      return (
        <li key={key}><Link to={'/orders/' + item.OrderId} onClick={this.toggleHeaderInfo}>- {this.renderTitle(item)}</Link></li>
      )
    }
    const renderNoti = () => {
      if (this.props.auth.departmentType === 1) return null
      if (headerInfo.Updates.length !== 0 && (hasSubscriptionPermission(this.props.auth, 30, 25) || hasAccess([6], auth.user.UserType))) {
        return (
          <div className='noti needTaksering' onClick={this.toggleHeaderInfo.bind(this, 'Updates_open')}>
            <Icon size='m' icon={HeaderIcons.Estimation_Request_White} ariaText={translation('2200')} ariaPos='bottom' />
            <div className='icon-number'>{headerInfo.Updates.length}</div>
          </div>
        )
      }
      return null
    }

    const renderMessages = () => {
      if (headerInfo.UnreadMessages === 0) return null
      return (
        <div className='noti'>
          <Link to='/mypage/messages' >
            <Icon size='m' icon={HeaderIcons.Message_With_Circle_White} />
            <div className='icon-number'>{this.props.headerInfo.UnreadMessages}</div>
          </Link>
        </div>
      )
    }

    const renderTasks = () => {
      if (!hasSubscriptionPermission(this.props.auth, 30) || this.props.headerInfo.IncompletedTasks === 0) return null
      return (
        <div className='noti'>
          <Link to='/mypage/tasks' >
            <Icon size='m' icon={HeaderIcons.Task_With_Circle_White} />
            <div className='icon-number'>{this.props.headerInfo.IncompletedTasks}</div>
          </Link>
        </div>
      )
    }

    const renderOrders = () => {
      if (!hasSubscriptionPermission(this.props.auth, 20) || this.props.headerInfo.AssignedOrders === 0) return null
      return (
        <div className='noti'>
          <Link to='/mypage/orders' >
            <Icon size='m' icon={HeaderIcons.Order_With_Circle_White} />
            <div className='icon-number'>{this.props.headerInfo.AssignedOrders}</div>
          </Link>
        </div>
      )
    }

    // Return
    // let SpecialBrowserClass = (navigator.appCodeName.indexOf('Mozilla') !== -1 && navigator.appName.indexOf('Netscape') !== -1 && navigator.appVersion.indexOf('like Gecko') !== -1 && navigator.appVersion.indexOf('Apple') === -1 && navigator.appVersion.indexOf('Chrome') === -1 || navigator.userAgent.indexOf('Edge') > -1) ? 'left' : ''
    let forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1 // Forsi is available for the company
    return (
      <div className='headerInfos' ref='container'>
        {renderNoti()}
        {this.state.headerInfos.EconomicMatches.length !== 0 && hasAccess([6], auth.user.UserType) && (
          <div className='noti needEconomicHandling' onClick={this.toggleHeaderInfo.bind(this, 'EconomicMatches_open')}>
            <Icon size='m' icon={HeaderIcons.Payment_Notification_White} ariaText={translation(13040)} ariaPos='bottom' />
            <div className='icon-number'>{this.state.headerInfos.EconomicMatches.length}</div>
          </div>
        )}
        {headerInfo.ManualMerges.length !== 0 && hasSubscriptionPermission(this.props.auth, 0, 4) && (
          <div className='noti needForsi' onClick={this.toggleHeaderInfo.bind(this, 'ManualMerges_open')}>
            <Icon size='m' icon={HeaderIcons.Update_With_Circle_White} ariaText={translation(auth.permissions.ChainAssessmentSystem === 2 ? 18065 : 2201)} ariaPos='bottom' />
            <div className='icon-number'>{headerInfo.ManualMerges.length}</div>
          </div>
        )}
        {forsiEnable && (!headerInfo.ForsiActive || (headerInfo.UsesForsiToken && !headerInfo.ForsiTokenActive)) && (
          <div className='noti' onClick={this.toggleHeaderInfo.bind(this, 'ForsiActive_open')}>
            <Icon size='m' icon={HeaderIcons.Forsi_Not_Active_White} ariaText={translation('1800')} ariaPos='bottom' />
          </div>
        )}
        {headerInfo.BookingPortalDrafts !== null && Array.isArray(headerInfo.BookingPortalDrafts) && headerInfo.BookingPortalDrafts.length !== 0 && (
          <div className='noti' onClick={this.toggleHeaderInfo.bind(this, 'BookingPortalDrafts_open')}>
            <Icon size='m' icon={HeaderIcons.BookingRequest_White} ariaText={translation(16749)} ariaPos='bottom' />
            <div className='icon-number'>{headerInfo.BookingPortalDrafts.length}</div>
          </div>
        )}
        {renderMessages()}
        {renderTasks()}
        {renderOrders()}
        {this.state.headerInfo.Updates_open && headerInfo.Updates.length !== 0 && (
          <div className='dropdown__menu'>
            <div>
              <strong>{translation('13363')}</strong>
              <ul>
                {headerInfo.Updates.map(renderUpdates)}
              </ul>
            </div>
          </div>
        )}
        {this.state.headerInfo.EconomicMatches_open && this.state.headerInfos.EconomicMatches.length !== 0 && (
          <div className='dropdown__menu'>
            <div>
              <strong>{translation('13040')}:</strong>
              <a className='search_link' onClick={this.searchEconomicNotMatched}>{translation('14810')}</a>
              <ul>
                {this.state.headerInfos.EconomicMatches.map(renderEconomicMatches)}
              </ul>
            </div>
          </div>
        )}
        {this.state.headerInfo.ManualMerges_open && headerInfo.ManualMerges.length !== 0 && (
          <div className='dropdown__menu'>
            <div>
              <strong>{translation('941')}</strong>
              <ul>
                {headerInfo.ManualMerges.map(renderMerge)}
              </ul>
            </div>
          </div>
        )}
        {this.state.headerInfo.ForsiActive_open && (!headerInfo.ForsiActive || (headerInfo.UsesForsiToken && !headerInfo.ForsiTokenActive)) && (
          <div className='dropdown__menu'>
            <div>
              <strong>{translation('6')}</strong>
              <ul>
                <li><Link to='/settings/forsi' onClick={this.toggleHeaderInfo}>- {translation('13438')}</Link></li>
              </ul>
            </div>
          </div>
        )}
        {this.state.headerInfo.BookingPortalDrafts_open && (
          <div className='dropdown__menu'>
            <div>
              <strong>{translation(16749)}</strong>
              <ul>
                {headerInfo.BookingPortalDrafts.map(renderBookingPortalDraft)}
              </ul>
            </div>
          </div>
        )}
      </div>
    )
  }

  render () {
    let backdropClass = ''
    let backdropClick = this.openMenu
    let loadingDiv
    let hasNotificationClass = ''
    if (this.props.headerInfo.ChainNotification !== null && this.props.headerInfo.ChainNotification !== '' && this.props.headerInfo.ChainNotification !== undefined) {
      hasNotificationClass = 'hasNotification'
    }
    if (this.props.backdrop.backdropOpen) {
      backdropClass += 'open '
    } else {
      backdropClass += 'closed '
    }
    if (this.props.backdrop.modalOpen && !this.props.backdrop.menuOpen) {
      backdropClass += 'modal-open '
    }
    if (this.props.backdrop.backdropHighZindex) {
      backdropClass += 'zindexBackdrop '
      backdropClick = false
      loadingDiv = (<div className='updating--state'><div>{translation('13382')}</div><i className='fa fa-spinner fa-spin fa-3x fa-fw' /></div>)
    }

    if (!this.props.backdrop.bodyScroll) {
      backdropClass += 'noScroll '
    }

    // Touch class
    let touchClass = 'body-no-touch'
    if (isTouchDevice()) {
      touchClass = 'body-has-touch'
    }

    // const freeBox = () => {
    //   if (!hasAccess([3, 4, 5, 7, 8], this.props.auth.user.UserType)) return null
    //   if (hasSubscriptionPermission(this.props.auth, 0)) return null
    //   return (
    //     <div className='freeBox'>
    //       <img src='/images/icons/Apromas-free200x200px.png' />
    //       <a href='/'>{translation('2147')} <b>{translation('2148').toUpperCase()}</b></a>
    //     </div>
    //   )
    // }

    const renderChainMsg = () => {
      let msg = this.props.headerInfo.ChainNotification
      if (msg === undefined || msg === null || msg === '') return null
      return (
        <div className='chain-notification'>
          <span>
            <div />
            <p>{msg}</p>
          </span>
        </div>
      )
    }
    // {false && freeBox()}
    // if (routeBlank.includes(this.props.location.pathname)) {
    //   return (
    //     <div className={'backdrop-' + backdropClass + ' ' + touchClass + ' ' + hasNotificationClass + ' ' + (this.props.backdrop.menuOpen ? 'menu-open' : 'menu-closed') + (this.props.hasOverlay ? ' overlay-open' : ' overlay-closed')}>
    //       <div className='layout__content'>
    //         {this.props.children}
    //       </div>
    //     </div>
    //   )
    // }
    // else {
    return (
      <div className={'backdrop-' + backdropClass + ' ' + touchClass + ' ' + hasNotificationClass + ' ' + (this.props.backdrop.menuOpen ? 'menu-open' : 'menu-closed') + (this.props.hasOverlay ? ' overlay-open' : ' overlay-closed')}>
        <div onClick={backdropClick} className={'backdrop ' + (this.props.backdrop.backdropOpen ? 'open' : 'closed')} />
        {loadingDiv}
        <ShortCutBar horizontal >
          <Menu openMenu={this.openMenu} menuOpen={this.props.backdrop.menuOpen} />
        </ShortCutBar>
        {renderChainMsg()}
        <TopBar router={this.props.router}>
          {this.renderHeaderInfo()}
          <div className='layout__dropdowns'>
            {hasAccess([4], this.props.auth.user.UserType) && this.props.auth.departmentType === 0 && <NewsFeed item={this.props.headerInfo.NewsItem} refreshItem={this.getHeaderInfo} />}
            <UserMenu router={this.props.router} />
          </div>
        </TopBar>
        <ShortCutBar>
          <Menu openMenu={this.openMenu} menuOpen={this.props.backdrop.menuOpen} />
        </ShortCutBar>
        <div className='layout__content'>
          {this.props.children}
        </div>
        {<ReportMergeOverlay item={this.state.selectedReportMergeInfo} />}
      </div>
    )
  }
  // }
}

Layout.propTypes = {
  setOrdersFilter: PropTypes.func.isRequired,
  backdrop: PropTypes.object.isRequired,
  triggerMenu: PropTypes.func.isRequired,
  isBlank: PropTypes.bool
}

Layout.defaultProps = {
  isBlank: false
}

function mapStateToProps (state) {
  let filter = state.orders.filterOrderlist
  if (hasAccess([4], state.auth.user.UserType)) {
    filter = state.orders.filterCustomer
  } else if (hasAccess([6], state.auth.user.UserType)) {
    filter = state.orders.filterWP
  } else if (state.routing.locationBeforeTransitions.pathname === '/workscreen') {
    filter = state.orders.filterWorkscreen
  }
  return {
    filter: filter,
    auth: state.auth,
    backdrop: state.backdrop,
    headerInfo: state.common.headerInfo,
    hasOverlay: state.common.overlays.length > 0
  }
}

export default connect(mapStateToProps, {
  triggerMenu,
  getHeaderInfo,
  setHeaderInfo,
  UpdateEconomicMatch,
  getOrdersAdvanced,
  setOrdersFilter,
  setOrdersSearch,
  openOverlay
})(Layout)



// WEBPACK FOOTER //
// ./src/app/shared/components/Layout/index.js